import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormFieldConfig } from '@devwareapps/devware-cap';
import { DateTimeUtilService } from '../../util/date-time-util.service';


@DwComponent({
  key: 'duration-form-control2',
  name: 'Duration Form Contorl',
  componentType: DwComponentType.formControl,
  isGlobal: true,
})
@Component({
  selector: 'app-duration-form-control',
  template: `
    <div class="read-only">
       {{formattedDuration || 'None'}}
    </div>
  `
})
export class DurationFormControlComponent implements DwFormControl, OnInit {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  inputClass: string = "form-control";
  @Input() context: DwContext;
  formattedDuration: string;

  constructor(private dateTimeUtilService: DateTimeUtilService) { }

  ngOnInit() {
    this.updateValue();

    this.control.valueChanges.subscribe(value => {
      this.updateValue();
    });


  }

  private updateValue() {
    this.formattedDuration = this.dateTimeUtilService.formatDurationMinutesSeconds(this.control.value);
  }

  /*
   * Returns the rating Form Control to get or set it's value
   */
  get control(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }

}
